import { Menu, Section } from '../../MarketingCampaigns.promo.services'
import { BNGM_SCOPE, BuyNGetMRuleState } from './types'

export function resolveEligibleNames(
	rule: BuyNGetMRuleState,
	sections: Section[] | undefined,
	allMenus: Menu | undefined,
	selectedShopIds: string[] | undefined,
): string[] {
	if (rule.scopeType === BNGM_SCOPE.PRODUCTS) {
		return rule.products.map((item) => {
			const section = sections?.find((s) => s.id === item.productSectionKey)
			const product = section?.products?.find((p) => p.key === item.productKey)
			return product?.name || item.productKey
		})
	}

	if (!rule.selectedOptionListKey) {
		return []
	}

	const optionListKey = rule.selectedOptionListKey
	const names = (selectedShopIds || [])
		.map((shopId) => {
			const categories = shopId ? (allMenus?.[shopId] as any)?.categories : null
			return categories?.[optionListKey]?.name || null
		})
		.filter(Boolean)

	const uniqueNames = Array.from(new Set(names))
	return uniqueNames.length > 0 ? uniqueNames : [optionListKey]
}
